import { Flex } from "antd";
import { styled } from "styled-components";

export const ContainerReservation = styled(Flex)`
    @media (max-width: 500px) {
        justify-content: center!important;
    }
`;

export  const AppointmentContainer = styled.div`
    display: grid;
    grid-template-columns: 100px 20px 200px 1fr;

    .inside-actions {
        display: none;
    }
    
    @media (max-width: 600px) {
        grid-template-columns: 40px 20px 100px 1fr;
    }
   
    @media (max-width: 500px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        jusitfy-content: center;
        width: 100%;
        
        .appointment-divider {
            display: none;
        }

        .inside-actions {
            display: flex;
        }
    }

    
`;

export const ActionsContainer = styled(Flex)`
    @media (max-width: 500px) {
        display: none;
    }
`;